import { SupplierDirectoryRow } from '../../../../types/advise';

export type SupplierSortField = 'supplier_name' | 'location' | 'pricing_model' | 'categories';

export interface SupplierSort {
  field: SupplierSortField;
  direction: 'asc' | 'desc';
}

export interface SupplierView {
  search: string;
  category: string | null;
  sort: SupplierSort;
}

const sortValue = (row: SupplierDirectoryRow, field: SupplierSortField): string =>
  (field === 'categories' ? row.categories.join(', ') : row[field]) ?? '';

/** The directory rows the search and Category filter keep, sorted; a row with nothing to sort by goes last. */
export const visibleSuppliers = (rows: SupplierDirectoryRow[], view: SupplierView): SupplierDirectoryRow[] => {
  const search = view.search.trim().toLowerCase();
  const { field, direction } = view.sort;
  return rows
    .filter((row) => !search || row.supplier_name.toLowerCase().includes(search))
    .filter((row) => !view.category || row.categories.includes(view.category))
    .sort((a, b) => {
      const [left, right] = [sortValue(a, field), sortValue(b, field)];
      if (!left || !right) return Number(!left) - Number(!right);
      const order = left.localeCompare(right, undefined, { sensitivity: 'base' });
      return direction === 'asc' ? order : -order;
    });
};

/** The filtered category first, so a collapsed row still shows why it matched. */
export const categoriesFirst = (categories: string[], category: string | null): string[] =>
  category && categories.includes(category)
    ? [category, ...categories.filter((item) => item !== category)]
    : categories;
